// funnelState.ts — persistência mínima do funil: sem dados pessoais em storage.

const LEAD_ID_KEY = "udi_lead_id";
const SLOT_KEY = "udi_slot";

export type ContactData = {
  name?: string;
  email?: string;
  phone?: string;
};

export type AnswersData = Record<number, string | number>;

export const funnelState = {
  getLeadId: (): number | null => {
    const raw = sessionStorage.getItem(LEAD_ID_KEY);
    return raw ? Number(raw) : null;
  },
  setLeadId: (id: number) => sessionStorage.setItem(LEAD_ID_KEY, String(id)),

  getSlotId: (): number | null => {
    const raw = sessionStorage.getItem(SLOT_KEY);
    return raw ? Number(raw) : null;
  },
  setSlotId: (id: number) => sessionStorage.setItem(SLOT_KEY, String(id)),

  clear: () => {
    sessionStorage.removeItem(LEAD_ID_KEY);
    sessionStorage.removeItem(SLOT_KEY);
    sessionStorage.removeItem("udi_lead_token");
  },
};
